import { FunctionComponent, memo } from "react";
import { IProps } from "./similarity-threshold-tooltip.types";
import "./similarity-threshold-tooltip.scss";

/**
 * A tooltip to show the similarity threshold and the similarity percentage so the user can see the difference.
 * @param props.similarityThreshold  The similarity threshold.
 * @param props.similarityPercentage The similarity percentage.
 */
const SimilarityThresholdTooltip: FunctionComponent<IProps> = ({ similarityThreshold, similarityPercentage }) => {
    return (
        <div className="similarity-threshold-tooltip">
            <div className="similarity-threshold-tooltip__value">
                <div className="similarity-threshold-tooltip__threshold-label">Trigger Threshold</div>
                <strong>{similarityThreshold}%</strong>
            </div>
            <div className="similarity-threshold-tooltip__value">
                <div className="similarity-threshold-tooltip__similarity-label">Sentence Similarity</div>
                <strong>{similarityPercentage}%</strong>
            </div>
        </div>
    );
};

export default memo(SimilarityThresholdTooltip);
